import { last } from 'lodash';
import React from 'react';

import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';
import RedirectLink from 'pages/Search/components/RedirectLink';

import useStyles from './styles';

interface Breadcrumb {
    to: string;
    label: React.ReactNode;
    disabled?: boolean;
}

interface Props {
    className?: string;
    items: MayBeNil<Breadcrumb>[];
}

const Breadcrumbs: React.FC<Props> = (props) => {
    const { className, items } = props;
    const { classes } = useStyles();
    return (
        <MuiBreadcrumbs
            separator={<ChevronRightRoundedIcon className={classes.separator} />}
            classes={{
                root: classes.root,
                ol: classes.ol
            }}
            className={className}
        >
            {items
                .filter((item): item is Breadcrumb => !!item)
                .map((item, index, array) => (
                    <RedirectLink
                        key={index}
                        to={item.to}
                        label={item.label}
                        active={item.disabled || item === last(array) ? false : true}
                        className={classes.link}
                    />
                ))}
        </MuiBreadcrumbs>
    );
};

export default Breadcrumbs;
